import { render, staticRenderFns } from "./customThemeModal.vue?vue&type=template&id=5ef13655&scoped=true&"
import script from "./customThemeModal.vue?vue&type=script&lang=js&"
export * from "./customThemeModal.vue?vue&type=script&lang=js&"
import style0 from "./customThemeModal.vue?vue&type=style&index=0&id=5ef13655&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef13655",
  null
  
)

export default component.exports